export function centsToEuro(value: number): string {
    value /= 100;
    let result: string = value.toString();
    if (value % 1 !== 0) {
        result = value.toFixed(2).replace(/\./g, ',');
    }
    result = result.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return '€' + result;
}
